<template>
    <div class="chat-attachment-bar">
        <div class="d-flex align-items-center flex-wrap">
            <input
                ref="fileInput"
                type="file"
                class="sr-only"
                tabindex="-1"
                aria-label="Selecionar anexo do chat"
                :accept="accept"
                :disabled="busy"
                @change="selectFile"
            />

            <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                :disabled="busy"
                @click="$refs.fileInput.click()"
            >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M21 11.5l-8.5 8.5a6 6 0 0 1-8.5-8.5l9-9a4 4 0 0 1 5.7 5.7l-9 9a2 2 0 0 1-2.9-2.9L15 6.5" />
                </svg>
                Anexar arquivo
            </button>

            <button
                type="button"
                class="btn btn-link btn-sm ml-1 chat-info-button"
                aria-label="Informações sobre documentos sigilosos"
                :aria-expanded="showInfo ? 'true' : 'false'"
                title="Orientação sobre documentos sigilosos"
                @click="showInfo = !showInfo"
            >
                <span class="chat-info-icon" aria-hidden="true">i</span>
            </button>

            <small class="text-muted ml-1">1 arquivo por mensagem · até 10 MB</small>
        </div>

        <div v-if="showInfo" class="alert alert-info mt-2 mb-1" role="note">
            <strong>Atenção:</strong> documentos sigilosos ou que necessitem de registro no
            prontuário devem ser anexados no <strong>Atendimento Técnico</strong>.
        </div>

        <div v-if="value" class="chat-selected-file mt-2 d-flex align-items-center flex-wrap">
            <div class="chat-file-label mr-2">
                <strong>{{ value.name }}</strong>
                <small class="text-muted d-block">{{ formatSize(value.size) }}</small>
            </div>

            <button type="button" class="btn btn-link btn-sm text-danger" :disabled="busy" @click="removeFile">
                Remover
            </button>

            <button type="button" class="btn btn-primary btn-sm ml-auto" :disabled="busy" @click="$emit('send')">
                {{ busy ? 'Enviando…' : 'Enviar anexo' }}
            </button>
        </div>

        <small v-if="value" class="text-muted d-block mt-1">
            Para enviar com uma mensagem, digite o texto e use o botão de envio do chat.
        </small>

        <div v-if="error" class="alert alert-danger mt-2 mb-0" role="alert">{{ error }}</div>
    </div>
</template>

<script>
import { ATTACHMENT_ACCEPT, formatFileSize, validateAttachment } from './chatAttachments';

export default {
    props: {
        value: { default: null },
        busy: { type: Boolean, default: false },
    },
    data() {
        return { accept: ATTACHMENT_ACCEPT, showInfo: false, error: '' };
    },
    methods: {
        formatSize: formatFileSize,
        selectFile(event) {
            const file = event.target.files && event.target.files[0];
            // Permite selecionar novamente o mesmo arquivo após removê-lo ou após um erro.
            event.target.value = '';

            if (!file) {
                return;
            }

            this.error = validateAttachment(file);
            this.$emit('input', this.error ? null : file);
        },
        removeFile() {
            this.error = '';
            this.$emit('input', null);
            this.$refs.fileInput.value = '';
        },
    },
};
</script>

<style scoped>
.chat-attachment-bar { padding: 8px 0; }
.chat-info-button { color: #176b80; line-height: 1; }
.chat-info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: 1.5px solid currentColor;
    border-radius: 50%;
    font-weight: bold;
    font-family: Georgia, serif;
    font-size: 16px;
}
.chat-selected-file { border: 1px solid #d9e1e8; border-radius: 6px; padding: 8px; background: #f8fafc; }
.chat-file-label { flex: 1; min-width: 100px; overflow-wrap: anywhere; word-break: break-word; }
</style>
